var React = require('react');

function MenuClosedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 13H11","stroke":"#212355","strokeWidth":"2","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M0 7H18","stroke":"#212355","strokeWidth":"2","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M0 1H18","stroke":"#212355","strokeWidth":"2","strokeLinejoin":"round","key":2})]);
}

MenuClosedInline.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = MenuClosedInline;

MenuClosedInline.default = MenuClosedInline;
